import React, {Component} from 'react';
import CSSModules from 'react-css-modules';
import classnames from 'classnames';
import styles from './styles.scss';

class TimeCell extends Component {
    constructor(props) {
        super(props);
        this.name = 'TagsCell';
      }
    render() {
        var tagToolTipStr = '';
        for(var i = 1; i < this.props.tags.tagsList.length;) {
            tagToolTipStr = tagToolTipStr + (i != 1 ?  ' ,' : '') + this.props.tags.tagsList[i];
            i = i + 1;
        }
        var tagsNumberStr = '';
        if((this.props.tags.tagsNum - 1) >= 1 ) {
            tagsNumberStr = ' (+'+(this.props.tags.tagsNum - 1)+')';
        }
    	if (parseInt(this.props.tags.tagsNum) == 0) {
    		return (<div></div>); 
    	}
        return (<div data-title={tagToolTipStr} data-hastooltip="true" data-titleposition="top"><span>{this.props.tags.mainTag}</span><span>{tagsNumberStr}</span></div>);
    }
  
}

export default CSSModules(TimeCell, styles);


// WEBPACK FOOTER //
// ./components/qual/Table/TableCells/Tags/TagsCell_component.js